/**
 * Nome/chave da permissão vinculada ao report-link.
 * @param {Object} reportLink
 * @returns {string|null}
 */
export function getReportLinkPermissionName(reportLink) {
  const permissionKey =
    reportLink?.permissionKey ??
    reportLink?.permission_key ??
    reportLink?.permission?.key ??
    null;
  if (permissionKey != null && String(permissionKey).trim() !== "") {
    return String(permissionKey).trim();
  }

  const fromRole = reportLink?.role?.name;
  if (fromRole != null && String(fromRole).trim() !== "") {
    return String(fromRole).trim();
  }

  const roleId = reportLink?.roleId ?? reportLink?.role_id;
  if (roleId != null && String(roleId).trim() !== "") {
    return String(roleId).trim();
  }

  return null;
}
